.header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 1rem;
}

.heading {
    color: var(--mantine-color-gneis-9);
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.5;
    margin: 0 0 0 0.5rem;
}
